import ReactRouterPrompt from "react-router-prompt";
import LeaveConfirmDialog from "./leave-confirm-dialog";

type IProps = {
  when: boolean;  
};

export default function LeaveRouterPrompt (props: IProps) {
  return (
    <ReactRouterPrompt when={props.when}>
      {({ isActive, onConfirm, onCancel }) =>
        <LeaveConfirmDialog open={isActive} handleLeave={onConfirm} handleClose={onCancel} />
      }
    </ReactRouterPrompt>
  );
}